import React from 'react';
import RadioBoxContainer from './RadioBoxContainer';

export default function FieldsInfoTransfer({
  client,
  register,
  errors,
  checked,
  check,
  setCheck,
  setChecked,
  control,
  setValue,
  purposes,
  purposeFromTransfer,
  tenantId,
  emdVisible,
  setFieldsEMDVisible,
  realtorData,
  setRealtorData,
  showREAInfoFill,
  radioChecked,
}) {
  const purposesOptions = purposes.map((purpose) => ({
    value: purpose,
    label: purpose,
  }));

  return (
    <RadioBoxContainer
      setCheck={setCheck}
      setChecked={setChecked}
      checked={checked}
      tenantId={tenantId}
      radioChecked={radioChecked}
      purposeFromTransfer={purposeFromTransfer}
    />
  );
}
